// @ts-nocheck

window._ = require("lodash");

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

import { i18n } from "./localization";

import "lazysizes";

window.Vue = require("vue").default;

Vue.prototype.svg = require("./svg");

Vue.component("estates-slider", require("./components/estates/slider").default);
Vue.component("estates-filter", require("./components/estates/filter").default);
Vue.component("estate-price", require("./components/estates/price").default);
Vue.component("estate-name", require("./components/estates/name").default);
Vue.component("estate-status", require("./components/estates/status").default);
Vue.component("estate-images", require("./components/estates/images").default);
Vue.component("estate-projects", require("./components/estates/projects").default);

// parts
Vue.component("part-purpose", require("./components/estates/parts/purpose").default);
Vue.component("part-status", require("./components/estates/parts/status").default);
Vue.component("part-state", require("./components/estates/parts/state").default);
Vue.component("part-sub-category", require("./components/estates/parts/sub-category").default);

// Whise detail parts
Vue.component("whise-detail", require("./components/estates/parts/whise-detail").default);

Vue.component("search-estate-form", require("./components/estates/search-form").default);
Vue.component("estimate-estate-form", require("./components/estates/estimate-form").default);
Vue.component("estate-contact", require("./components/estates/contact").default);

Vue.component("usps-slider", require("./components/usps/slider").default);

Vue.component("offices-slider", require("./components/offices/slider").default);

Vue.component("wordpress-video", require("./components/wordpress/video").default);
Vue.component("wordpress-contact-form", require("./components/wordpress/contact").default);

Vue.component("image-slider", require("./components/general/image-slider").default);
Vue.component("price-hubl", require("./components/general/price-hubl").default);

Vue.component("refresh-form", require("./components/sweepbright/refresh-form").default);

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

new Vue({
    i18n,
    el: "#app",

    data: () => ({
        menuOpen: false
    }),

    mounted() {
        this.$nextTick(() => {
            const header: HTMLElement = document.querySelector(".main-header");

            window.onscroll = function() {
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    header.classList.add("scrolled");
                } else {
                    header.classList.remove("scrolled");
                }
            };
        });
    },
    methods: {
        pushOrSlice(array: Array<string | number>, prop: string | number) {
            if (array.includes(prop)) {
                array.splice(array.indexOf(prop), 1);
            } else {
                array.push(prop);
            }

            return array;
        },
        disableScrolling(disable: boolean) {
            const body: HTMLElement = document.querySelector("body");

            if (disable) {
                body.classList.add("overflow-y-hidden");
            } else {
                body.classList.remove("overflow-y-hidden");
            }
        },
        openCalendly(url) {
            Calendly.initPopupWidget({ url: url, text: "Plan een afspraak", color: "#006bff", textColor: "#ffffff", branding: true });
        }
    }
});
